import { TranslationsContext } from '@teliaee/telia-translate';
import { observer } from 'mobx-react';
import * as React from 'react';
import { Button, Grid, GridColumn, Notice, TextField } from '@teliaee/design-system';

export interface IReferenceNumberFormProps {
  value: string;
  onChange: (string) => void;
  isInvalid: boolean;
  invalidText: string;
  buttonText: string;
  onSubmit: (string) => void;
  result: string;
}

const ReferenceNumberForm = observer((props: IReferenceNumberFormProps) => {
  const { value, onChange, isInvalid, invalidText, buttonText, result, onSubmit } = props;
  const { translate } = React.useContext(TranslationsContext);

  return (
    <div className="text">
      <Grid align={['bottom-sm']}>
        <GridColumn width={['lg-4', 'md-5', 'sm-7']}>
          <TextField
            id="referencePhone"
            label={translate('prepaid.phonenumber')}
            prefix="+372"
            type="tel"
            value={value}
            onChange={onChange}
            isInvalid={isInvalid}
            errorMessage={isInvalid ? invalidText : undefined}
            onKeyDown={(event) => {
              if (event.key === 'Enter') {
                onSubmit(value);
              }
            }}
          />
        </GridColumn>
        <GridColumn width={['sm']}>
          <Button type="primary" text={buttonText} onClick={onSubmit} />
        </GridColumn>
      </Grid>
      {result && <Notice type="success">{result}</Notice>}
    </div>
  );
});

export default ReferenceNumberForm;
